import { useEffect } from 'react';
import { useAppSelector } from '@/hooks/redux';
import { useTabBadges } from '@/api-frontend/updateTabBadges';

/**
 * Component that automatically syncs navigation badges with app state
 * This component should be included once in the app to maintain badge accuracy
 */
export function NavigationSync() {
  const { refreshBadges, updateBadges } = useTabBadges();
  
  // Watch for changes in state that should trigger badge updates
  const conversationCount = useAppSelector(state => state.conversations.totalCount);
  const newsContext = useAppSelector(state => state.news.newsContext);
  const locationError = useAppSelector(state => state.location.error);
  const locationPermission = useAppSelector(state => state.location.locationPermission);
  const currentLocation = useAppSelector(state => state.location.currentLocation);

  // Sync badges when relevant state changes
  useEffect(() => {
    const updates = [];

    // Update discover badge based on news
    if (newsContext?.totalItems) {
      updates.push({
        tabId: 'discover',
        badge: newsContext.totalItems > 99 ? '99+' : newsContext.totalItems.toString()
      });
    } else {
      updates.push({ tabId: 'discover', badge: null });
    }

    // Update conversations badge based on saved conversations
    if (conversationCount > 0) {
      updates.push({
        tabId: 'conversations', 
        badge: conversationCount > 99 ? '99+' : conversationCount.toString()
      });
    } else {
      updates.push({ tabId: 'conversations', badge: null });
    }

    // Update settings badge based on issues
    let settingsBadge = null;
    if (locationError || locationPermission === 'denied' || !currentLocation) {
      settingsBadge = '!';
    }
    updates.push({ tabId: 'settings', badge: settingsBadge });

    updateBadges(updates);
  }, [
    conversationCount, 
    newsContext, 
    locationError, 
    locationPermission, 
    currentLocation,
    updateBadges
  ]);

  // Initial badge refresh on mount
  useEffect(() => {
    refreshBadges();
  }, [refreshBadges]);

  // This component renders nothing
  return null;
}

export default NavigationSync;